/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';
import Avis from 'images/avis-success.svg';
import CallCTA from 'components/CallCTA';
import CTA from 'components/CTA';
import { DEPARTEMENTS_LEAD_HELLIO_TRAVAUX } from 'constants/leads';
import { openCreneauAppel } from 'utils/creneauAppel';

class NavSuccess extends React.Component {
  shouldHideCTA = () => {
    if (
      this.props.answers?.Q1 === 'thermostat' ||
      this.props.answers?.Q17 === 'Copropriété' ||
      this.props.answers?.Q43 === "J'ai reçu des devis et les ai signés"
    ) {
      return true;
    }

    return this.props.answers?.['Q53.V2'] === 'Collectif';
  };

  shouldShowDatePicker = () => {};

  render() {
    const transactionId = this.props?.result?.data?.hubspot_transactionId;
    const parcours = this.props.answers?.Q1;
    const isChauffageIsolation =
      parcours === 'chauffage' || parcours === 'isolation';
    const isDiagnosticLogement =
      parcours === 'diagnosticLogement' || parcours === 'auditEnergetique';
    const isDPE = this.props.answers.Q1 === 'diagnosticLogement';
    const shouldHidePicker =
      isChauffageIsolation ||
      parcours === 'accessibilite' ||
      parcours === 'nonRenseigne';
    const isHellioTravaux = DEPARTEMENTS_LEAD_HELLIO_TRAVAUX.includes(
      this.props.answers?.Q26?.postalcode?.substring(0, 2),
    );
    const isDevisSigne =
      this.props.answers?.Q43 === "J'ai reçu des devis et les ai signés";
    const showCTA =
      !this.shouldHideCTA() && !(shouldHidePicker && transactionId);
    const showRappel = (transactionId && !isDevisSigne) || isDiagnosticLogement;

    const buttonCaption = isChauffageIsolation
      ? isHellioTravaux
        ? 'Être contacté par un expert Hellio'
        : 'Être contacté par un partenaire RGE'
      : transactionId
        ? 'Choisir un créneau d’appel'
        : 'Être rappelé';
    const rappelConfirmation = isDiagnosticLogement
      ? isDPE
        ? '👉 Avec Hellio Ingénierie, commandez votre DPE dès maintenant et lancez votre projet de rénovation en toute sérénité.'
        : '👉 Avec Hellio Ingénierie, commandez votre audit dès maintenant et lancez votre projet de rénovation en toute sérénité.'
      : isChauffageIsolation && !isHellioTravaux
        ? 'Votre inscription a bien été prise en compte.\nUn partenaire RGE va prendre contact avec vous dans les plus brefs délais pour donner suite à votre projet.'
        : 'Votre inscription a bien été prise en compte.\nUn expert Hellio va prendre contact avec vous dans les plus brefs délais pour donner suite à votre projet.';

    return (
      <>
        {showRappel && (
          <p
            className={clsx(
              '!text-sm bg-bleu-hellio-1 !p-2 rounded-lg whitespace-pre-line text-gris-hellio',
              {
                '!mb-1': showCTA,
                'leading-4 font-light': !isDiagnosticLogement,
                'leading-[20px] font-semibold ': isDiagnosticLogement,
              },
            )}
          >
            {rappelConfirmation}
          </p>
        )}

        {showCTA &&
          (isDiagnosticLogement ? (
            <CTA
              primaryAction={() =>
                window.open(
                  isDPE
                    ? 'https://ingenierie.hellio.com/solutions/dpe#commandez-dpe'
                    : 'https://ingenierie.hellio.com/solutions/audit#commandez-audit',
                  '_blank',
                )
              }
              primaryCaption={
                isDPE ? 'Commander mon DPE' : 'Commander mon audit'
              }
              secondaryAction={
                transactionId
                  ? () =>
                      openCreneauAppel(
                        'https://meetings.hubspot.com/charlotte-chouteau/round-robin-simulateur-kelvin-',
                        this.props.contact,
                      )
                  : null
              }
              secondaryCaption="Choisir un créneau d’appel"
            />
          ) : (
            <CallCTA
              {...this.props}
              contact={this.props.contact}
              showPicker={!shouldHidePicker && !transactionId}
              showPickerMainAction={!!transactionId}
              buttonCaption={buttonCaption}
              showUserFormDialog={!isDiagnosticLogement}
            />
          ))}

        <div className="only-show-mobile">
          <div className="navigation-mobile-success">
            <div className="d-flex jcsb">
              <button className="btn-retour" onClick={this.props.lastStep}>
                <svg
                  width="35"
                  height="37"
                  viewBox="0 0 35 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="35" height="36.2572" rx="17.5" fill="white" />
                  <path
                    d="M15.9053 12.4395L10.3905 18.176L15.9053 23.8185"
                    stroke="#FBA03D"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="square"
                  />
                  <path
                    d="M11.5532 18.1758L24.6113 18.1758"
                    stroke="#FBA03D"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="square"
                  />
                </svg>
                <span className="gris-hellio">Retour</span>
              </button>
              <img src={Avis} alt="Avis" />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default NavSuccess;
